import script from "./Position.vue?vue&type=script&setup=true&lang=js"
export * from "./Position.vue?vue&type=script&setup=true&lang=js"

import "./Position.vue?vue&type=style&index=0&id=27fbc086&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fbc086"]])

export default __exports__